module.exports = __webpack_public_path__ + "static/media/bg-home-bottom-left.6ab8b6ec.png";